import { Button, Modal, Steps } from "antd";
import { useEffect, useRef, useState } from "react";
import WinnersInfoGeneral from "./WinnersInfoGeneral/WinnersInfoGeneral";
import WinnersImages from "./WinnersImages/WinnersImages";
import { showNotificationTopEnd } from "../../../../util/utils";
import { callCreateDashboardWinner, callUpdateDashboardWinner } from "../../../../services/winnersService";

const { Step } = Steps;

export default function WinnersModalSteps(props) {
    const { visible, onClose, selectedRecord = null } = props;
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState(selectedRecord);
    const [current, setCurrent] = useState(0);
    const stepRefs = [useRef(), useRef()];
    const [photos, setPhotos] = useState([]);
    const isEdit = Boolean(selectedRecord);


    useEffect(() => {
        setFormData(selectedRecord);
        if (visible) {
            setCurrent(0);
        } else {
            setFormData(null);
            setPhotos([]);
        }
    }, [selectedRecord, visible]);


    const steps = [
        {
            title: "Ganadores Info",
            description: "Info. General",
            content: (
                <WinnersInfoGeneral
                    visible={visible}
                    ref={stepRefs[0]}
                    formData={formData}
                    isEdit={isEdit}
                    onUpdate={(updated) => setFormData({ ...formData, ...updated })} />
            ),
        },
        {
            title: "Fotos",
            description: "Fotos Ganadores",
            content: (
                <WinnersImages
                    visible={visible}
                    ref={stepRefs[1]}
                    formData={formData}
                    isEdit={isEdit}
                    onUpdate={(updated) => setFormData({ ...formData, ...updated })}
                    photos={photos}
                    onUpdatePhotos={(updater) => setPhotos((prev) => typeof updater === "function" ? updater(prev) : updater)} />
            ),
        },
    ];


    const next = async () => {
        const currentRef = stepRefs[current];
        if (currentRef?.current?.validate) {
            try {
                await currentRef.current.validate();
                setCurrent((prev) => prev + 1);
            } catch (err) {
                showNotificationTopEnd("error", "Valida los campos del formulario");
            }
        } else {
            setCurrent((prev) => prev + 1);
        }
    };


    const prev = () => setCurrent((prev) => prev - 1);


    const handleFinishSteps = async () => {
        setLoading(true);

        let response = null;
        if (isEdit) {
            response = await callUpdateDashboardWinner(formData, photos);
        } else {
            response = await callCreateDashboardWinner(formData, photos);
        }
        if (response?.status === 200) {
            //form.resetFields();
            onClose();
            showNotificationTopEnd(
                "success",
                isEdit ? "Ganador actualizado" : "Ganador creado"
            );
        } else {
            showNotificationTopEnd("error", "Error al guardar");
        }

        setLoading(false);
    };


    return (
        <Modal
            open={visible}
            onCancel={onClose}
            footer={null}
            width={1100}
            centered
            destroyOnHidden
        >
            <Steps current={current} size="large" style={{ marginBottom: 24 }}>
                {steps.map((item, index) => (
                    <Step key={index} title={item.title} description={item.description} />
                ))}
            </Steps>

            <div style={{ minHeight: 200 }}>{steps[current].content}</div>

            <div style={{ marginTop: 24, textAlign: "right" }}>
                {current > 0 && (
                    <Button onClick={prev} style={{ marginRight: 8 }}>
                        Anterior
                    </Button>
                )}
                {current < steps.length - 1 && (
                    <Button type="primary" onClick={next}>
                        Siguiente
                    </Button>
                )}
                {current === steps.length - 1 && (
                    <Button type="primary"
                        onClick={handleFinishSteps}
                        loading={loading}>
                        Finalizar
                    </Button>
                )}
            </div>
        </Modal>
    );
}